import { useAuth } from './useAuth';
import { canWritePage, canDeleteFromPage, canAccessPage } from '../utils/permissions';

export const usePermissions = () => {
  const { user } = useAuth();

  const checkPageAccess = (page: string) => canAccessPage(user, page);
  const checkWritePermission = (page: string) => canWritePage(user, page);
  const checkDeletePermission = (page: string) => canDeleteFromPage(user, page);

  return {
    canAccess: checkPageAccess,
    canWrite: checkWritePermission,
    canDelete: checkDeletePermission,
  };
};